import { render } from "./new-document.vue?vue&type=template&id=3f8822ea"
import script from "./new-document.vue?vue&type=script&lang=js"
export * from "./new-document.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__